import React from 'react';
import {RoutePermittedRole} from 'shared/constants/AppConst';

const ShiftTypeCreateForm= React.lazy(()=>import('./NewShiftsType'))
const ShiftListingTypePage= React.lazy(()=>import('./ShiftTypeListing'))
const ShiftTypeEditPage= React.lazy(()=>import('./EditShiftType'));
export const ShiftsTypeConfigs = [
  {
    permittedRole: RoutePermittedRole.corporateAdmin,
    path: '/onboard-corporate/shift-type/create',
    element: <ShiftTypeCreateForm />,
  },
  {
    permittedRole: RoutePermittedRole.corporateAdmin,
    path: '/onboard-corporate/shift-type/edit/:id',
    element: <ShiftTypeEditPage />,
  },
  {
    permittedRole: RoutePermittedRole.corporateAdmin,
    path: '/onboard-corporate/shift-type/list',
    element: <ShiftListingTypePage/>,
  },
 

];
